import { useInCreateDialog } from 'components/create-dialog/CreateDialogContext';
import MainCard from 'components/MainCard';
import { useSelector } from 'store';
import { cn } from 'utils/cn';

type Props = {
    children: React.ReactNode;
};

/** The card a page form sits in. The create dialog is the form's surface there, so it adds none. */
const FormWrapper = ({ children }: Props) => {
    const { focusedEditMode } = useSelector((state) => state.menu);
    const inCreateDialog = useInCreateDialog();

    if (inCreateDialog) {
        return children;
    }

    return (
        <MainCard
            content={false}
            border={!focusedEditMode}
            // Visible, so the form's sticky `ActionHeader` sticks to the scroll container rather than the card.
            className={cn('overflow-visible rounded-none', focusedEditMode && 'bg-transparent')}
        >
            {children}
        </MainCard>
    );
};

export default FormWrapper;
